import React, { useState, useEffect } from 'react';
import HomePage from './components/HomePage';
import RoomPage from './components/RoomPage';
import './App.css';

function App() {
  const [page, setPage] = useState({ name: 'home' });

  useEffect(() => {
    // Simple hash-based routing
    const handleHash = () => {
      const hash = window.location.hash;
      const match = hash.match(/^#\/room\/([a-zA-Z0-9-]+)/);
      if (match) {
        setPage({ name: 'room', roomId: match[1] });
      } else {
        setPage({ name: 'home' });
      }
    };
    handleHash();
    window.addEventListener('hashchange', handleHash);
    return () => window.removeEventListener('hashchange', handleHash);
  }, []);

  const navigateTo = (path) => {
    window.location.hash = path;
  };

  if (page.name === 'room') {
    return <RoomPage roomId={page.roomId} navigate={navigateTo} />;
  }
  return <HomePage navigate={navigateTo} />;
}

export default App;
